// import * as types from '../types';
import { ActionContext, ActionTree, GetterTree } from "vuex";
import { SeibiItem } from "@/model/InspectionSeibi";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import { INSPECT_TYPE } from "@/model/InspectType";
import { DO_SEIBI } from "@/model/DoSeibi";
import * as util from "@/service/util";

export interface SeibiDataState {
  seibi: SeibiItem[][];
  hasData: boolean;
  isConfirmLegal56: number;
  isConfirmRecommend: number;
  manualItems: any;
  listInspectId: number[]
}
const initialState: SeibiDataState = {
  seibi: [[], [], []],
  hasData: false,
  isConfirmLegal56: 0,
  isConfirmRecommend: 0,
  manualItems: [],
  listInspectId: []
};

const actions: ActionTree<SeibiDataState, any> = {
  setSeibiData(
    { commit }: ActionContext<SeibiDataState, any>,
    payload: any
  ): void {
    commit("setSeibiData", payload);
  },
  updateDotenken(
    { commit }: ActionContext<SeibiDataState, any>,
    payload: SeibiItem
  ): void {
    commit("updateDotenken", payload);
  },
  updateInspectDoTenken(
    { commit }: ActionContext<SeibiDataState, any>,
    payload: SeibiItem
  ): void {
    commit("updateInspectDoTenken", payload);
  },
  updateDoTenkenFromSocket(
    { commit }: ActionContext<SeibiDataState, any>,
    payload: any
  ): void {
    commit("updateDoTenkenFromSocket", payload);
  },
  editPrice(
    { commit }: ActionContext<SeibiDataState, any>,
    payload: any
  ): void {
    commit("editPrice", payload);
  },
  confirm(
    { commit }: ActionContext<SeibiDataState, any>,
    payload: { type: number; value: number }
  ): void {
    commit("confirm", payload);
  },
  clearState({ commit }: ActionContext<SeibiDataState, any>): void {
    commit("clearState");
  },
  setListInspectId({ commit }: ActionContext<SeibiDataState, any>, payload: SeibiItem[]): void {
    commit("setListInspectId", payload);
  }
};

const mutations = {
  setSeibiData(state: SeibiDataState, payload: any) {
    let items: any = Object.values(payload.items);
    // if (items.length > 3) {
    //   items = items.slice(0, 3);
    // }
    items.forEach((item: any) => {
      item.forEach((seibi: SeibiItem) => {
        if (seibi.buhinEditTotalZk == null) {
          seibi.buhinEditTotalZk = seibi.buhinZk;
        }
        if (seibi.kouchinEditZk == null) {
          seibi.kouchinEditZk = seibi.kouchinZk;
        }
        // if (seibi.kouchinEditZk < 0) {
        //   seibi.kouchinEditZk = 0;
        // }
        /** 2023-10-19 invoice [START] */
        if (seibi.buhinEditTotalZn == null) {
          seibi.buhinEditTotalZn = seibi.buhinZn;
        }
        if (seibi.kouchinEditZn == null) {
          seibi.kouchinEditZn = seibi.kouchinZn;
        }
        seibi.totalZk = seibi.buhinEditTotalZk + seibi.kouchinEditZk;
        seibi.totalZn = seibi.buhinEditTotalZn + seibi.kouchinEditZn;
        /** 2023-10-19 invoice [END] */
      });
    });
    state.seibi = [...items];
    if (payload.manualItems && payload.manualItems[2].length > 0) {
      state.manualItems = payload.manualItems[2];
      state.manualItems.forEach((seibi: SeibiItem) => {
        if (seibi.buhinEditTotalZk == null) {
          seibi.buhinEditTotalZk = seibi.buhinZk;
        }
        if (seibi.kouchinEditZk == null) {
          seibi.kouchinEditZk = seibi.kouchinZk;
        }
        /** 2023-10-19 invoice [START] */
        if (seibi.buhinEditTotalZn == null) {
          seibi.buhinEditTotalZn = seibi.buhinZn;
        }
        if (seibi.kouchinEditZn == null) {
          seibi.kouchinEditZn = seibi.kouchinZn;
        }
        seibi.totalZk = seibi.buhinEditTotalZk + seibi.kouchinEditZk;
        seibi.totalZn = seibi.buhinEditTotalZn + seibi.kouchinEditZn;
        /** 2023-10-19 invoice [END] */
      });
    } else {
      state.manualItems = [];
    }
    state.hasData = true;
  },
  updateDotenken(state: SeibiDataState, payload: SeibiItem) {
    if (
      state.manualItems &&
      state.manualItems.length > 0 &&
      payload.sknUketsukeManualSeibiId
    ) {
      const j = state.manualItems.findIndex(
        (item: any) =>
          item.sknUketsukeManualSeibiId != null &&
          item.sknUketsukeManualSeibiId == payload.sknUketsukeManualSeibiId
      );
      if (j > -1) {
        let seibi = {
          ...state.manualItems[j],
          doTenken: payload.doTenken,
          kouchinZk: payload.kouchinZk,
          /** 2023-10-19 invoice [START] */
          kouchinZn: payload.kouchinZn,
          buhinZk: payload.buhinZk,
          buhinZn: payload.buhinZn,
          buhinEditTotalZk: payload.buhinEditTotalZk,
          buhinEditTotalZn: payload.buhinEditTotalZn,
          kouchinEditZk: payload.kouchinEditZk && payload.kouchinEditZk > 0 ? payload.kouchinEditZk : 0
          , totalZk: (payload.kouchinEditZk && payload.kouchinEditZk > 0 ? payload.kouchinEditZk : 0) + (payload.buhinEditTotalZk ? payload.buhinEditTotalZk: 0),
          kouchinEditZn: payload.kouchinEditZn && payload.kouchinEditZn > 0 ? payload.kouchinEditZn : 0
          , totalZn: (payload.kouchinEditZn && payload.kouchinEditZn > 0 ? payload.kouchinEditZn : 0) + (payload.buhinEditTotalZn ? payload.buhinEditTotalZn: 0)
          /** 2023-10-19 invoice [END] */
        };
        state.manualItems[j] = seibi;
      }
    } else if (state.seibi[payload.sknInspectType]) {
      let i = state.seibi[payload.sknInspectType].findIndex(
        (item: SeibiItem) =>
          item.sknInspectSeibiId != null &&
          item.sknInspectSeibiId == payload.sknInspectSeibiId
      );
      if (i > -1) {
        state.seibi[payload.sknInspectType][i] = payload;
      }
      /** 2024-03-01 sh #8804(BQRxxx) 赤画面△の「する」「しない」選択操作をした際に 勝手に他部位の「する」「しない」が動く。 MFノースジャパン様 No.25 [START] */
      else if (payload.sknInspectType == 1 && state.seibi[0]) {
        let i = state.seibi[0].findIndex(
          (item: SeibiItem) =>
            item.sknInspectSeibiId != null &&
            item.sknInspectSeibiId == payload.sknInspectSeibiId &&
            item.sknInspectType == payload.sknInspectType
        );
        if (i > -1) {
          state.seibi[0][i] = payload;
        }
      }
      /** 2024-03-01 sh #8804(BQRxxx) 赤画面△の「する」「しない」選択操作をした際に 勝手に他部位の「する」「しない」が動く。 MFノースジャパン様 No.25 [END] */
    }
  },
  updateInspectDoTenken(state: SeibiDataState, payload: SeibiItem) {
    let listSeibi = state.seibi[payload.sknInspectType].filter(
      (item: SeibiItem) =>
        item.sknInspectId != null && item.sknInspectId == payload.sknInspectId
    );
    if (listSeibi.length > 0) {
      listSeibi.forEach(seibi => {
        seibi.doTenken = payload.doTenken;
      });
    }
    if (state.manualItems && state.manualItems.length > 0) {
      let listManualSeibi = state.manualItems.filter(
        (item: any) =>
          item.sknInspectId != null && item.sknInspectId == payload.sknInspectId
      );
      if (listManualSeibi.length > 0) {
        listManualSeibi.forEach((seibi: any) => {
          seibi.doTenken = payload.doTenken;
        });
      }
    }
  },
  updateDoTenkenFromSocket(state: SeibiDataState, payload: any) {
    for (let j = 0; j <= 3; j++) {
      mutations.updateDotenken(state, {
        ...payload,
        sknInspectType: j,
        sknUketsukeInspectSeibiId: payload.sknUketsukeInspectSeibiId
      });
    }
  },
  editPrice(state: SeibiDataState, payload: any) {

    if (
      state.manualItems &&
      state.manualItems.length > 0 &&
      payload.sknUketsukeInspectSeibiManualId
    ) {
      const j = state.manualItems.findIndex(
        (item: any) =>
          item.sknUketsukeManualSeibiId != null &&
          item.sknUketsukeManualSeibiId == payload.sknUketsukeInspectSeibiManualId
      );
      if (j > -1) {
        let seibi = {
          ...state.manualItems[j]
        };
        setEditedPrice(seibi, payload);
        state.manualItems[j] = seibi;
      }
    } else {
      let targetId = payload.sknUketsukeInspectSeibiId;
      //事前見積ONの時に並び替えの関係で手入力(ManualId)のstoreがmanualItemsではなくseibiに含まれる動作に対応
      if( targetId == null && payload.sknUketsukeInspectSeibiManualId ){
        targetId = payload.sknUketsukeInspectSeibiManualId;
      }
      for (let sknInspectType = 0; sknInspectType < state.seibi.length; sknInspectType++) {
        let index = state.seibi[sknInspectType].findIndex(
          (item: SeibiItem) =>
            item.sknInspectSeibiId != null &&
            item.sknInspectSeibiId == targetId
        );
        if (index > -1) {
          let seibi = {
            ...state.seibi[sknInspectType][index]
          };
          setEditedPrice(seibi, payload);
          state.seibi[sknInspectType][index] = seibi;
          return;
        }
      }
    }
  },
  confirm(state: SeibiDataState, payload: { type: number; value: number }) {
    if (payload.type == INSPECT_TYPE.LEGAL56) {
      state.isConfirmLegal56 = payload.value;
    } else {
      state.isConfirmRecommend = payload.value;
    }
  },
  clearState(state: SeibiDataState) {
    Object.assign(state, util.deepCopy(initialState));
  },
  setListInspectId(state: SeibiDataState, payload: SeibiItem[]) {
    if (payload.length > 0) {
      let ids: any = payload.map(e => e.sknInspectId);
      ids = ids.filter((item: any, pos: number) => {
        return ids.indexOf(item) == pos;
      });
      state.listInspectId = ids;
    } else {
      state.listInspectId = [];
    }
    // Object.assign(state, util.deepCopy(initialState));
  }
};

const getters: GetterTree<SeibiDataState, any> = {
  getSeibiData(state: SeibiDataState) {
    return [...state.seibi];
  },
  getManualSeibiData(state: SeibiDataState) {
    return state.manualItems;
  },
  hasData(state: SeibiDataState) {
    return state.hasData;
  },
  getByInspectResult: (state: SeibiDataState) => (
    inspectType: number,
    inspectResult: number
  ) => {
    let seibi = JSON.parse(JSON.stringify(state.seibi));
    let seibi1 = seibi[inspectType];
    if (seibi1 && seibi1.length > 0) {
      return seibi1.filter(
        // 2022-01-31 morisako kobac-free mod [START]
        // (item: SeibiItem) => item.inspectResult == inspectResult
        (item: SeibiItem) => (item.inspectResult == inspectResult && item.isDiscount != 1)
        // 2022-01-31 morisako kobac-free mod [END]
      );
    } else {
      return [];
    }
  },
  getByInspectDescriptionId: (state: SeibiDataState) => (
    sknInspectDescriptionId: string
  ) => {
    let seibi = JSON.parse(JSON.stringify(state.seibi));
    let foundSeibi = null;
    for (let i = 0; i < seibi.length; i++) {
      let seibi1 = seibi[i];
      if (seibi1 && seibi1.length > 0) {
        foundSeibi = seibi1.find(
          (item: SeibiItem) =>
            item.sknInspectDescriptionId == Number(sknInspectDescriptionId)
        );
        if (foundSeibi) {
          return {
            ...foundSeibi,
            kouchinZk: +foundSeibi.kouchinZk,
            buhinZk: +foundSeibi.buhinZk
          };
        }
      }
    }
    return null;
  },
  // 2022-01-31 morisako kobac-free mod [START]
  getByIsDiscount: (state: SeibiDataState) => (
    inspectType: number,
    inspectResult: number
  ) => {
    let seibi = JSON.parse(JSON.stringify(state.seibi));
    let seibi1 = seibi[inspectType];
    if (seibi1 && seibi1.length > 0) {
      return seibi1.filter(
        (item: SeibiItem) => (item.inspectResult == inspectResult && item.isDiscount == 1)
      );
    } else {
      return [];
    }
  },
  // 2022-01-31 morisako kobac-free mod [END]
  listInspect_Gensha_56: (state: SeibiDataState, getters) => {
    let _list: SeibiItem[][] = [];
    let gensha1 = getters.getByInspectResult(
      INSPECT_TYPE.GENSHA,
      InspectButtonValue.CIRCLE
    );
    let legal1 = getters.getByInspectResult(
      INSPECT_TYPE.LEGAL56,
      InspectButtonValue.CIRCLE
    );
    let line1 = getters.getByInspectResult(1, InspectButtonValue.CIRCLE);
    _list.push(gensha1.concat(legal1).concat(line1));

    let gensha2 = getters.getByInspectResult(
      INSPECT_TYPE.GENSHA,
      InspectButtonValue.CROSS
    );
    let legal2 = getters.getByInspectResult(
      INSPECT_TYPE.LEGAL56,
      InspectButtonValue.CROSS
    );
    let line2 = getters.getByInspectResult(2, InspectButtonValue.CROSS);
    _list.push(gensha2.concat(legal2).concat(line2));

    let gensha3 = getters.getByInspectResult(
      INSPECT_TYPE.GENSHA,
      InspectButtonValue.TRIANGLE
    );
    let legal3 = getters.getByInspectResult(
      INSPECT_TYPE.LEGAL56,
      InspectButtonValue.TRIANGLE
    );
    _list.push(gensha3.concat(legal3));
    return _list;
  },
  listInspectByType: (state: SeibiDataState, getters) => (
    inspectType: number
  ) => {
    if (inspectType == INSPECT_TYPE.RECOMMEND) {
      // 2022-01-31 morisako kobac-free mod [START]
      let discountList1 = getters.getByIsDiscount(
        inspectType,
        InspectButtonValue.CROSS
      );
      let discountList2 = getters.getByIsDiscount(
        inspectType,
        InspectButtonValue.TRIANGLE
      );
      // 2022-01-31 morisako kobac-free mod [END]
      let list1 = getters.getByInspectResult(
        inspectType,
        InspectButtonValue.CROSS
      );
      let list2 = getters.getByInspectResult(
        inspectType,
        InspectButtonValue.TRIANGLE
      );
      let list3 = getters.getByInspectResult(
        inspectType,
        InspectButtonValue.CIRCLE
      );
      let list9 = getters.getByInspectResult(
        inspectType,
        InspectButtonValue.NOPRIORITY
      );
      let list4 = getters.getByInspectResult(
        INSPECT_TYPE.RECOMMEND_MANUAL,
        InspectButtonValue.CROSS
      );
      let list5 = getters.getByInspectResult(
        INSPECT_TYPE.RECOMMEND_MANUAL,
        InspectButtonValue.TRIANGLE
      );
      let list6 = getters.getByInspectResult(
        INSPECT_TYPE.RECOMMEND_MANUAL,
        InspectButtonValue.CIRCLE
      );
      let list7 = manualListInspectByType(
        state.manualItems,
        INSPECT_TYPE.USER_MANUAL,
        InspectButtonValue.FREE
      );
      let list8 = getters.getByInspectResult(
        INSPECT_TYPE.RECOMMEND_MANUAL,
        InspectButtonValue.NOPRIORITY
      );
      let list10 = manualListInspectByType(
        state.manualItems,
        INSPECT_TYPE.RECOMMEND_MANUAL,
        InspectButtonValue.FREE
      );
      // 2023-09-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
      let list11 = getters.getByInspectResult(
        INSPECT_TYPE.RECOMMEND_MANUAL,
        InspectButtonValue.FREE
      );
      // 2023-09-00 BQR1092(809) add 明細の並び順とextreme取込 [END]
      // 2023-09-00 BQR1092(809) mod 明細の並び順とextreme取込 [START]
      // 2022-01-31 morisako kobac-free mod [START]
      // let list = list1.concat(list2).concat(list3).concat(list9).concat(list4).concat(list5).concat(list6).concat(list8).concat(list7).concat(list10);
      // let list = discountList1.concat(discountList2).concat(list1).concat(list2).concat(list3).concat(list9)
      //           .concat(list4).concat(list5).concat(list6).concat(list8).concat(list7).concat(list10);
      // 2022-01-31 morisako kobac-free mod [START]
      let list = discountList1.concat(discountList2).concat(list1).concat(list2).concat(list3).concat(list9)
                .concat(list4).concat(list5).concat(list6).concat(list8).concat(list7).concat(list10).concat(list11);
      // 2023-09-00 BQR1092(809) mod 明細の並び順とextreme取込 [END]
      if (list && list.length > 0) {
        let r = 0;
        for (let i = 0; i < list.length; i++) {
          if (list[i].sknInspectType == 4 && list[i].rowNum == 0) {
            list[i].rowNum = 0
          } else {
            r += 1;
            list[i].rowNum = r;
          }
        }
      }
      return list;
    } else {
      // 2022-01-31 morisako kobac-free add [START]
      let discountList1 = getters.getByIsDiscount(
        inspectType,
        InspectButtonValue.CROSS
      );
      let discountList2 = getters.getByIsDiscount(
        INSPECT_TYPE.GENSHA,
        InspectButtonValue.CROSS
      );
      let discountList3 = getters.getByIsDiscount(
        inspectType,
        InspectButtonValue.TRIANGLE
      );
      let discountList4 = getters.getByIsDiscount(
        INSPECT_TYPE.GENSHA,
        InspectButtonValue.TRIANGLE
      );
      // 2022-01-31 morisako kobac-free add [END]
      let list1 = getters.getByInspectResult(
        INSPECT_TYPE.GENSHA,
        InspectButtonValue.CROSS
      );
      let list2 = manualListInspectByType(
        state.manualItems,
        INSPECT_TYPE.GENSHA,
        InspectButtonValue.CROSS
      );
      let list3 = getters.getByInspectResult(
        inspectType,
        InspectButtonValue.CROSS
      );
      let list4 = manualListInspectByType(
        state.manualItems,
        inspectType,
        InspectButtonValue.CROSS
      );
      let list5 = getters.getByInspectResult(
        INSPECT_TYPE.GENSHA,
        InspectButtonValue.TRIANGLE
      );
      let list6 = manualListInspectByType(
        state.manualItems,
        INSPECT_TYPE.GENSHA,
        InspectButtonValue.TRIANGLE
      );
      let list7 = getters.getByInspectResult(
        inspectType,
        InspectButtonValue.TRIANGLE
      );
      let list8 = manualListInspectByType(
        state.manualItems,
        inspectType,
        InspectButtonValue.TRIANGLE
      );
      /** 202-02-10 sh #7719(BQR067) add manual seibi of jizen. [START] */
      let list9 = manualListInspectByType(
        state.manualItems,
        INSPECT_TYPE.JIZEN,
        InspectButtonValue.TRIANGLE
      );
      let list10 = manualListInspectByType(
        state.manualItems,
        INSPECT_TYPE.JIZEN,
        InspectButtonValue.CROSS
      );
      /** 202-02-10 sh #7719(BQR067) add manual seibi of jizen. [END] */
      let listLine1 = getters.getByInspectResult(
        INSPECT_TYPE.INSPECT_LINE,
        InspectButtonValue.CROSS
      );
      let listLine2 = manualListInspectByType(
        state.manualItems,
        INSPECT_TYPE.INSPECT_LINE,
        InspectButtonValue.CROSS
      );
      let listLine3 = getters.getByInspectResult(
        INSPECT_TYPE.INSPECT_LINE,
        InspectButtonValue.TRIANGLE
      );
      let listLine4 = manualListInspectByType(
        state.manualItems,
        INSPECT_TYPE.INSPECT_LINE,
        InspectButtonValue.TRIANGLE
      );

      /** 2021-07-14 sh #7237 add sort for AK-0004. [START] */
      list1.sort((a: SeibiItem,b: SeibiItem) => {
        if (a.sknInspectId > b.sknInspectId) return 1;
        if (a.sknInspectId < b.sknInspectId) return -1;

        if (a.sknInspectSeibiId > b.sknInspectSeibiId) return 1;
        if (a.sknInspectSeibiId < b.sknInspectSeibiId) return -1;
        return 0;
      });
      list5.sort((a: SeibiItem,b: SeibiItem) => {
        if (a.sknInspectId > b.sknInspectId) return 1;
        if (a.sknInspectId < b.sknInspectId) return -1;

        if (a.sknInspectSeibiId > b.sknInspectSeibiId) return 1;
        if (a.sknInspectSeibiId < b.sknInspectSeibiId) return -1;
        return 0;
      });
      /** 2021-07-14 sh #7237 add sort for AK-0004. [END] */

      // 2022-01-31 morisako kobac-free mod [START]
      // return list1
      return discountList1
        .concat(discountList2)
        .concat(discountList3)
        .concat(discountList4)
        .concat(list1)
      // 2022-01-31 morisako kobac-free mod [END]
        .concat(list2)
        .concat(list3)
        .concat(list4)
        /** 202-02-10 sh #7719(BQR067) add manual seibi of jizen. [START] */
        .concat(list10)
        /** 202-02-10 sh #7719(BQR067) add manual seibi of jizen. [END] */
        .concat(listLine1)
        .concat(listLine2)
        .concat(list5)
        .concat(list6)
        .concat(list7)
        .concat(list8)
        /** 202-02-10 sh #7719(BQR067) add manual seibi of jizen. [START] */
        .concat(list9)
        /** 202-02-10 sh #7719(BQR067) add manual seibi of jizen. [END] */
        .concat(listLine3)
        .concat(listLine4);
    }
  },
  sumPriceByType: (state: SeibiDataState, getters) => (inspectType: number) => {
    let listSeibi = getters
      .listInspectByType(inspectType)
      .filter((item: SeibiItem) => +item.doTenken == DO_SEIBI.suru);
    let totalZk = listSeibi.reduce(
      (sum: number, cur: SeibiItem) =>
        sum + (
          ( cur.buhinEditTotalZk ? ( cur.buhinEditTotalZk < 0 ? 0: cur.buhinEditTotalZk ) : 0 ) || 0)
           + ((cur.kouchinEditZk ? cur.kouchinEditZk < 0 ? 0: cur.kouchinEditZk: 0 ) || 0),
      0
    );
    let totalZn = listSeibi.reduce(
      (sum: number, cur: SeibiItem) =>
        sum + (
          ( cur.buhinEditTotalZn ? ( cur.buhinEditTotalZn < 0 ? 0: cur.buhinEditTotalZn ) : 0 ) || 0)
           + ((cur.kouchinEditZn ? cur.kouchinEditZn < 0 ? 0: cur.kouchinEditZn: 0 ) || 0),
      0
    );
    return { totalZk, totalZn };
  },
  isConfirmLegal56(state: SeibiDataState) {
    return state.isConfirmLegal56;
  },
  isConfirmRecommend(state: SeibiDataState) {
    return state.isConfirmRecommend;
  },
  doTenkenById: (state: SeibiDataState, getters) => (
    inspectType: number,
    sknInspectId: number
  ) => {
    if (state.hasData && state.seibi[inspectType]) {
      const i = state.seibi[inspectType].findIndex(
        (item: SeibiItem) =>
          item.sknInspectId != null && item.sknInspectId == sknInspectId
      );
      if (i > -1) {
        return state.seibi[inspectType][i].doTenken;
      }
    }
    return 0;
  },
  nextInspectId: (state: SeibiDataState, getters) => (
    currentId: number
  ) => {
    const currentIndex = state.listInspectId.indexOf(currentId);
    if (currentIndex < state.listInspectId.length - 1) {
      return state.listInspectId[currentIndex + 1];
    }
    return - 1;
  },
  prevInspectId: (state: SeibiDataState, getters) => (
    currentId: number
  ) => {
    const currentIndex = state.listInspectId.indexOf(currentId);
    if (currentIndex > 0) {
      return state.listInspectId[currentIndex - 1];
    }
    return - 1;
  }
};

function manualListInspectByType(
  manualItems: any,
  inspecType: number,
  inspectResult: number
) {
  if (manualItems && manualItems.length > 0) {
    const listFilterd = manualItems.filter(
      (item: any) =>
        item.sknInspectType == inspecType && item.inspectResult == inspectResult
    );
    return listFilterd.map((seibi: any) => {
      return {
        ...seibi,
        sknInspectSeibiDescriptionNm: seibi.sknInspectSeibiDescriptionNm,
        // sknInspectSeibiId: seibi.sknUketsukeManualSeibiId,
        sknUketsukeManualSeibiId: seibi.sknUketsukeManualSeibiId,
        sknUketsukeExtendsId: seibi.sknUketsukeExtendsId,
        sknInspectId: seibi.sknInspectId,
        sknInspectType: seibi.sknInspectType
      };
    });
  }
  return [];
}

function setEditedPrice(seibi: any, payload: any) {
  seibi.buhinEditTotalZk = payload.buhinEditTotalZk != null ? payload.buhinEditTotalZk : seibi.buhinZk;
  seibi.buhinEditTotalZn = payload.buhinEditTotalZn != null ? payload.buhinEditTotalZn : seibi.buhinZn;
  seibi.kouchinEditZk = payload.kouchinEditZk != null ? payload.kouchinEditZk : seibi.kouchinZk;
  seibi.kouchinEditZn = payload.kouchinEditZn != null ? payload.kouchinEditZn : seibi.kouchinZn;
  // if (seibi.kouchinEditZk < 0) {
  //   seibi.kouchinEditZk = 0;
  // }
  // if (seibi.kouchinEditZn < 0) {
  //   seibi.kouchinEditZn = 0;
  // }
}

export default {
  namespaced: true,
  state: util.deepCopy(initialState),
  getters,
  mutations,
  actions
};
